import { format, isValid } from "date-fns";

// 12-hour clock: 12, 01, 02, …, 11  ("00" is not a valid 12-hour label)
export const HOURS = ["12", ...Array.from(Array(11)).map(
  (_, index) =>
    `${(index + 1).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`
)];

export const MINUTES = Array.from(Array(12)).map(
  (_, index) =>
    `${(index * 5).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`
);

export const AM_PM = ["am", "pm"];

export const timeStringToDate = (
  date: Date,
  hour: string,
  minute: string,
  amPm: string
) => {
  const timeString = `${convertHour12to24(hour, amPm === "am")}:${
    formatDigit(minute) || "00"
  }:00`;

  return new Date(`${format(date || new Date(), "yyyy-MM-dd")}T${timeString}`);
};

export const formatDigit = (value?: string | number | null) => {
  if (value === null || value === undefined || isNaN(parseInt(value as string)))
    return "";

  return Number(value.toString().trim()).toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
};

export const convertHour24to12 = (value: string) => {
  const number = Number(formatDigit(value));
  if (number === 0 || number === 12) return "12";
  return formatDigit(number > 12 ? number - 12 : number);
};

export const convertHour12to24 = (value: string, isAm: boolean) => {
  const number = Number(formatDigit(value)) || 0;
  if (isAm) {
    if (number >= 12) return "00";

    return formatDigit(number);
  } else {
    if (number >= 12) return "12";

    return formatDigit(number + 12);
  }
};

export const dateToParts = (
  value: Date,
  hour: string,
  minute: string,
  amPm: string
) => {
  const result = {
    hour: formatDigit(hour) || "00",
    minute: formatDigit(minute) || "00",
    amPm: amPm,
    timeString: "",
  };

  if (value && isValid(value)) {
    result.minute = formatDigit(value?.getMinutes());
    if (value?.getHours() >= 12) {
      result.amPm = "pm";
    } else {
      result.amPm = "am";
    }
    result.hour = formatDigit(convertHour24to12(value?.getHours().toString()));
  }
  result.timeString = `${result.hour}:${result.minute} ${result.amPm}`;
  return result;
};
